import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=06f17ec9&scoped=true&"
import script from "./Transactions.vue?vue&type=script&lang=tsx&"
export * from "./Transactions.vue?vue&type=script&lang=tsx&"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=06f17ec9&scoped=true&lang=less&"
import style1 from "./Transactions.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f17ec9",
  null
  
)

export default component.exports